/**
 * Each harness type's colour, from the `--harness-<type>` brand
 * tokens. The class strings are written out in full so Tailwind finds them.
 *
 * A type with no entry keeps the generic look it has always had, and its
 * label still says which kind it is.
 */
const MARK: Record<string, string> = {
  'claude-code': 'bg-harness-claude-code/12 text-harness-claude-code',
  codex: 'bg-harness-codex/12 text-harness-codex',
};

// The chip's words take the `-ink` token: the foreground in the light theme,
// where terracotta and teal fall short of 4.5:1 on their own tint, and the
// colour itself in the dark theme.
const CHIP: Record<string, string> = {
  'claude-code': 'bg-harness-claude-code/12 text-harness-claude-code-ink',
  codex: 'bg-harness-codex/12 text-harness-codex-ink',
};

const MARKED = ['claude-code', 'codex'] as const;

export type MarkedHarnessType = (typeof MARKED)[number];

/** The round mark beside a harness's name in the list. */
export function harnessMarkClass(harnessType: string): string {
  return MARK[harnessType] ?? 'bg-destructive/12 text-destructive';
}

/** The engine chip under a harness's name. */
export function harnessChipClass(harnessType: string): string {
  return CHIP[harnessType] ?? 'bg-muted text-muted-foreground';
}

/** Whether the type has its own mark (`ToolMark`) rather than the generic icon. */
export function hasHarnessMark(
  harnessType: string,
): harnessType is MarkedHarnessType {
  return (MARKED as readonly string[]).includes(harnessType);
}
